
<template>
    <div class="tw-footer tw-footer--padded tw-responsive__xs--half-padding tw-responsive__xxs--half-padding">
        <div v-if="dmnOptions.widgetMode === 'default-view'" class="tw-text--center">
            <button type="button" class="tw-btn__link" v-on:click="goToTop()">
                <font-awesome-icon icon="chevron-up" />
                Back to top
            </button>
        </div>

        <div class="tw-footer__poweredby tw-text--right" v-if="!dmnOptions.hidePoweredBy">
            <a v-bind:href="dmnOptions.poweredBy.url" v-bind:title="dmnOptions.poweredBy.title" target="_blank">
                <img v-bind:src="dmnOptions.poweredBy.logo" v-bind:alt="dmnOptions.poweredBy.title" />
            </a>
        </div>
    </div>
</template>

<script lang='ts'>
    import { Vue } from "vue-property-decorator";
    import { Component } from "vue-property-decorator";
    import TicketWidgetComponent from '../../TicketWidgetComponent';
    import TagOptions from '../../../models/TagOptions';

    //fontawesome
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import { faChevronUp } from '@fortawesome/free-solid-svg-icons';

    library.add(faChevronUp);

    @Component({
        components: {
            FontAwesomeIcon
        }
    })

    export default class WidgetFooter extends TicketWidgetComponent {
        goToTop() {
            window.scrollTo(0,0);
        }
    }
</script>